import { Pipe, PipeTransform } from '@angular/core';
import { PauseAlertingWindow } from '../models/hierarchy.model';
import { DateTimeFormatOptions } from 'luxon';
import { CurrentUser } from '../models/user.model';

@Pipe({
  name: 'pauseAlertingWindowLabel',
  standalone: false
})
export class PauseAlertingWindowLabelPipe implements PipeTransform {
  transform(
    pauseAlertingWindow: PauseAlertingWindow,
    user: CurrentUser
  ): { [key: string]: string } {
    const { start, end, requestor, reason } = pauseAlertingWindow;
    const options: DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
      timeZone: user.timeZone
    };

    return {
      ['start']: `${start.toLocaleString(user.language, options)}`,
      ['end']: `${end.toLocaleString(user.language, options)}`,
      ['requestor']: requestor.email,
      ['reason']: reason
    };
  }
}
